import { windowWidth, windowHeight } from "../layout";
// bootstrap
import Collapse from 'bootstrap/js/dist/collapse';
// gsap
import { gsap, smoother } from "../layout";
// swiper
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, EffectCreative, Thumbs, Autoplay, Grid } from 'swiper/modules';
// fancyapps
import { Fancybox } from "@fancyapps/ui";
// lazysizes
import 'lazysizes';

// banner swiper
var bannerSwiper = new Swiper(".banner__swiper", {
    modules: [ Navigation, Pagination, EffectCreative, Autoplay ],
    speed: 1300,
    allowTouchMove: true,
    loop: true,
    autoplay: {
        delay: 1600,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".banner__swiper-button-next",
        prevEl: ".banner__swiper-button-prev",
    },
    pagination: {
        el: ".banner__swiper-pagination",
    },
    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: false,
            translate: ["-20%", 0, -1],
        },
        next: {
            translate: ["100%", 0, 0],
        },
    },
    breakpoints: {
        992: {
            allowTouchMove: false,
        },
    },
});
bannerSwiper.autoplay.stop();

// banner section 
function bannerSection() {
    // responsive view
    const bannerSwiper = document.querySelector('.banner__swiper');
    const bannerAds = document.querySelector('.banner__ads');
    const bannerAdsMobile = document.querySelector('.banner__ads-mobile');
    
    if(bannerAds) {
        if (window.innerWidth > 1024) {
            bannerSwiper.append(bannerAds);
        } else if(window.innerWidth <= 1024) {
            bannerAdsMobile.append(bannerAds);
        }
    }
}

// about section
function aboutLayout() {
    // brush animate
    const about = document.querySelector('.about');
    const brushItems = document.querySelectorAll('.about__brush-item');
    const brushContainer = document.querySelectorAll('.about__brush-container');

    gsap.to(brushItems, {
        width: "130%",
        duration: 1,
        ease: "power4.out",
        stagger: 0.3,
        scrollTrigger: {
            trigger: brushContainer,
            start: "top center+=25%",
            // markers: true,
        },
    })

}
function aboutLayoutResponsive() {
    // mobile responsive
    const aboutContainer = document.querySelector('.about__container');
    const aboutDescriptionContainer = document.querySelector('.about__description-container');
    const aboutDescriptionMobile = document.querySelector('.about__description-wrapper-mobile');
    const aboutTitle = document.querySelector('.about__title');
    const aboutDescription = document.querySelector('.about__description');

    if (window.innerWidth < 576) {
        aboutDescriptionMobile.append(aboutTitle);
        aboutDescriptionMobile.append(aboutDescription);
    } else {
        aboutContainer.prepend(aboutTitle);
        aboutDescriptionContainer.append(aboutDescription);
    }
}

// gallery section
function galleryPhoto() {
    const galleryWrapper = document.querySelector('.gallery__photo-collection');
    const galleryItemDesktop = document.querySelectorAll('.gallery__desktop .gallery__image-item .gallery__image-container');
    const galleryItemMobile = document.querySelectorAll('.gallery__mobile .gallery__image-item .gallery__image-container');

    gsap.fromTo(galleryItemDesktop, {
        scale: 0.4,
        autoAlpha: 0,
    }, {
        scale: 1,
        autoAlpha: 1,
        duration: 0.8,
        ease: "power4.out",
        stagger: 0.2,
        scrollTrigger: {
            trigger: galleryWrapper,
            start: "top bottom-=20%",
            // markers: true,
        },
    })

    gsap.fromTo(galleryItemMobile, {
        scale: 0.4,
        autoAlpha: 0,
    }, {
        scale: 1,
        autoAlpha: 1,
        duration: 0.8,
        ease: "power4.out",
        stagger: 0.2,
        scrollTrigger: {
            trigger: galleryWrapper,
            start: "top bottom-=20%",
            // markers: true,
        },
    })

    // gallery on desktop
    Fancybox.bind('[data-fancybox="gallery-desktop"]', {
        Thumbs: false,
        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ["close"],
            },
        },
    });

    // gallery on mobile
    Fancybox.bind('[data-fancybox="gallery-mobile"]', {
        Thumbs: false,
        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ["close"],
            },
        },
    });

    // swiper on mobile
    var gallerySwiper = new Swiper(".gallery__swiper", {
        modules: [ Pagination ],
        speed: 1300,
        allowTouchMove: true,
        pagination: {
            el: ".gallery__swiper-pagination",
        },
    });
}
function galleryPhotoResponsive() {
    // remove 2 gallery item on desktop
    const galleryItemHidden = document.querySelectorAll('.gallery__desktop .gallery__image-item.gallery-hidden');
    galleryItemHidden.forEach((el) => {
        let imageMask = el.querySelector(".gallery__image-mask");

        if(innerWidth > 1024) {
            el.classList.add("d-none");
            imageMask.removeAttribute("data-fancybox");
        } else if(innerWidth >= 576 && innerWidth <= 1024) {
            el.classList.remove("d-none");
            imageMask.setAttribute("data-fancybox", "gallery-desktop");
        }
    })
}

// instagram section
let instagramGallery;
function initInstagramGallery() {
    instagramGallery = new Swiper('.instagram__swiper', {
        modules: [ Autoplay, Grid ],
        slidesPerView: 3,
        loop: true,
        spaceBetween: 14,
        speed: 4000,
        allowTouchMove: false,
        grid: {
            rows: 2,
        },
        autoplay: {
            delay: 0,
            reverseDirection: false,
        },
        breakpoints: {
            576: {
                slidesPerView: 4.4,
                spaceBetween: 15,
            },
            1025: {
                slidesPerView: 5,
                spaceBetween: 30,
            },
        },
    });
}

// faq section
function faqCard() {
    const faqButtonHeader = document.querySelectorAll('.faq__accordion-item');
    const accordionMobile = document.querySelector('.faq__accordion-item-wrapper.mobile-view');
    const accordionOdd = document.querySelector('.faq__accordion-item-wrapper.odd');
    const accordionEven = document.querySelector('.faq__accordion-item-wrapper.even');
    const faqQuote = document.querySelector('.faq__quote');

    faqButtonHeader.forEach((e) => {
        const itemButton = e.querySelector('.faq__accordion-button');
        const itemCollapse = e.querySelector('.faq__accordion-collapse');
        const itemOrder = e.getAttribute('data-order');
        
        if(window.innerWidth > 1024) {
            // console.log('faq > 1024');
            itemButton.setAttribute('disabled', '');
            itemCollapse.classList.add('show');
            if(itemOrder % 2 != 0) {
                // console.log('odd yaa');
                accordionOdd.append(e);
            } else if(itemOrder % 2 == 0) {
                // console.log('even yaa');
                accordionEven.append(e);
            }
            accordionEven.append(faqQuote);
            e.style.removeProperty('order');
        } else if(window.innerWidth <= 1024) {
            // console.log('faq <= 1024');
            itemButton.removeAttribute('disabled');
            itemCollapse.classList.remove('show');
            accordionMobile.append(e);
            accordionMobile.append(faqQuote);
            e.style.order = itemOrder;
        }
    })
}

// level section
function levelSection() {
    // perfect image
    const perfectImage = document.querySelector('.perfect-image');
    gsap.fromTo(perfectImage, {
        scale: 0.4,
        autoAlpha: 0,
    }, {
        scale: 1,
        autoAlpha: 1,
        duration: 0.7,
        delay: 0.6,
        ease: "power4.out",
        scrollTrigger: {
            trigger: perfectImage,
            start: "top bottom-=20%",
            // markers: true,
        },
    })

    // comparison table
    const comparisonTable = document.querySelector('.level__table');
    const comparisonItem = document.querySelectorAll('.level__header-image');
    gsap.fromTo(comparisonItem, {
        scale: 0.4,
        autoAlpha: 0,
    }, {
        scale: 1,
        autoAlpha: 1,
        duration: 0.6,
        ease: "power4.out",
        stagger: 0.2,
        scrollTrigger: {
            trigger: comparisonTable,
            start: "top bottom-=20%",
            // markers: true,
        },
    })

    // result arrow image
    const resultArrow = document.querySelector('.result-edited__result-arrow');
    gsap.fromTo(resultArrow, {
        yPercent: -50,
        scale: 0.4,
        autoAlpha: 0,
    }, {
        yPercent: 0,
        scale: 1,
        autoAlpha: 1,
        duration: 0.7,
        delay: 0.2,
        ease: "power4.out",
        scrollTrigger: {
            trigger: resultArrow,
            start: "top bottom-=20%",
            // markers: true,
        },
    })

    // result edited swiper
    var resultSwiperDescription = new Swiper(".result-edited__swiper-description", {
        loop: true,
        speed: 1300,
        spaceBetween: 60,
        allowTouchMove: false,
    });
    var resultSwiperImage = new Swiper(".result-edited__swiper-image", {
        modules: [ Pagination, EffectFade, Thumbs, Autoplay ],
        speed: 1300,
        grabCursor: true,
        effect: "fade",
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".result-edited__swiper-pagination",
        },
        thumbs: {
            swiper: resultSwiperDescription,
        },
    });
}

// menu section
function menuSection() {
    // mobile responsive
    if (windowWidth < 992) {
        const menuDiscountLabel = document.querySelector('.menu__discount-text .discount-label');
        const menuPriceWrapper = document.querySelector('.menu__discount .menu__price-wrapper');
    
        menuPriceWrapper.prepend(menuDiscountLabel);
    }
}

window.addEventListener('load', function(){
    setTimeout(() => {
        bannerSwiper.autoplay.start();
    }, "1000");
});

document.addEventListener("DOMContentLoaded", function () {
    bannerSection();
    aboutLayout();
    aboutLayoutResponsive();
    galleryPhoto();
    galleryPhotoResponsive();
    initInstagramGallery();
    faqCard();
    levelSection();
    menuSection();
})

window.addEventListener('resize', function(event) {
    bannerSection();
    aboutLayoutResponsive();
    galleryPhotoResponsive();
    faqCard();

    // instagram gallery section
    instagramGallery.destroy();
    initInstagramGallery()
}, true);